const EMPTY = '';
class ContentAudio {
    constructor(audio) {
        audio = audio.item || audio;
        this.id = audio.id;
        this.language = (audio.language || EMPTY).toLowerCase();
        this.team = (audio.homeAway || audio.type || EMPTY).toLowerCase();
        this.mediaState = audio.mediaState?.mediaStateCode || audio.mediaState;
        this.name = this.callSign = audio.callSign || audio.callLetters;
        this.mediaId = audio.mediaId;
    }
}

export default ContentAudio;
